var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"print-button"},[_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm"},on:{"click":function($event){return _vm.print()}}},[_c('shs-icon',{attrs:{"name":"print"}}),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }